import styled from '@emotion/styled';

const TextHighlights = styled.span`
  ${(props) => {
    return `
      white-space: pre;
      font-weight: ${props.highlight ? 700 : 400};
    `;
  }}
`;

export default TextHighlights;
